<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">High-value Goods Policy</h1>
        <p class="desc-text">Effective Date: August 5, 2025</p>

        <section class="content-section">
            <p class="desc-text">XigCheck applies enhanced review standards to selected high-value product categories.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">1. Covered Categories</h2>
            <p class="desc-text">Covered categories may include:</p>
            <ul class="policy-list">
                <li>luxury handbags</li>
                <li>luxury accessories</li>
                <li>premium sneakers</li>
                <li>collectible fashion items</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">2. Enhanced Review Standards</h2>
            <p class="desc-text">Certain high-value items may require:</p>
            <ul class="policy-list">
                <li>additional product images</li>
                <li>serial number consistency review</li>
                <li>condition review</li>
                <li>expert-assisted review</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">3. Marketplace Compliance</h2>
            <p class="desc-text">Listings associated with suspected counterfeit activity may be:</p>
            <ul class="policy-list">
                <li>removed</li>
                <li>restricted</li>
                <li>escalated for further review</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">4. No Financial or Asset Protection Services</h2>
            <p class="desc-text">XigCheck does not provide:</p>
            <ul class="policy-list">
                <li>insurance services</li>
                <li>escrow services</li>
                <li>financial guarantees</li>
                <li>transaction guarantees</li>
                <li>investment-related services</li>
            </ul>
            <p class="desc-text">All authentication services are limited to independent product review and marketplace trust support.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckHighValueGoodsPolicy'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
